import {computed} from "vue";
import {useRoute} from "vue-router/dist/vue-router";

const breadcrumb = {
    state: {
        breadcrumb: [
            {
                id: "0",
                label: "工作台",
                name: "",
                children: [
                    {
                        id: "0-1",
                        label: "工作台",
                        name: "HomePage",
                        children: [],
                    },
                ]
            },
            {
                id: "1",
                label: "课程管理",
                name: "",
                children: [
                    {
                        id: "1-1",
                        label: "课程管理",
                        name: "CoursesPage",
                        children: [],
                    },
                    {
                        id: "1-2",
                        label: "上传课程",
                        name: "UploadCoursesPage",
                        children: [],
                    },
                    {
                        id: "1-3",
                        label: computed(() => {
                            let str = "";
                            switch (useRoute().params.state) {
                                case "add":
                                    str = "新增课程";
                                    break;
                                case "modify":
                                    str = "修改课程";
                                    break;
                                case "see":
                                    str = "查看课程";
                                    break;
                                default:
                            }
                            return str;
                        }),
                        name: "NewTopicsPage",
                        children: [],
                    },
                ]
            },
            {
                id: "2",
                label: "系统设置",
                name: "",
                children: [
                    {
                        id: "2-1",
                        label: "角色管理",
                        name: "RolePage",
                        children: [],
                    },
                    {
                        id: "2-2",
                        label: "用户管理",
                        name: "UserPage",
                        children: [],
                    },
                    {
                        id: "2-3",
                        label: "组织管理",
                        name: "OrganizePage",
                        children: [],
                    },
                    {
                        id: "2-4",
                        label: "字典维护",
                        name: "DictPage",
                        children: [],
                    },
                ]
            },
        ],
    },
    mutations: {

    },
    actions: {
        GET_BREADCRUMB({ state, rootState, commit, dispatch, getters }, name) {

            let nodesWithParents = findNodeAndAncestors(state.breadcrumb, name);
            return flattenChildren(nodesWithParents);
        }
    }
}


function findNodeAndAncestors(nodes, name) {

    function findNodeAndAncestorsRecursive(node, name) {

        if (node.name === name) {
            return { ...node, children: [] }; // 如果当前节点就是目标节点，则直接返回该节点及其子节点为空数组
        }
        if (node.children) {
            for (let child of node.children) {
                // 递归查找目标节点
                const result = findNodeAndAncestorsRecursive(child, name);
                if (result) {
                    // 如果找到目标节点，则返回当前节点及其子节点
                    return { ...node, children: [result] };
                }
            }
        }
        return null; // 如果当前节点不是目标节点，也没有子节点，则返回 null
    }

    let result = [];
    for (let node of nodes) {
        // 对于每个根节点，递归查找目标节点
        const ancestor = findNodeAndAncestorsRecursive(node, name);
        if (ancestor) {
            result.push(ancestor); // 如果找到目标节点，则将结果添加到最终结果中
        }
    }
    return result;
}


function flattenChildren(nodes) {
    let result = [];

    nodes.forEach(node => {
        result.push(node);
        if (node.children && node.children.length) {
            result = result.concat(flattenChildren(node.children));
            delete node.children; // 如果不需要保留children属性，可以删除
        }
    });

    return result;
}


export default breadcrumb;
